import { render, staticRenderFns } from "./org-widget.vue?vue&type=template&id=5f33c361&scoped=true"
import script from "./org-widget.vue?vue&type=script&lang=js"
export * from "./org-widget.vue?vue&type=script&lang=js"
import style0 from "./org-widget.vue?vue&type=style&index=0&id=5f33c361&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f33c361",
  null
  
)

export default component.exports